export function convertUppercaseLabelToCapitalize(status?: string) {
  if (!status) return "-";
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
}
